import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './DashboardPage.css';

const USER = {
  
  company: 'Welcome to your personal health dashboard',
};

const COUPONS = [
  {
    id: 'c1',
    title: 'Vitamin D Test',
    description:
      'Get your Vitamin D levels checked at a special price on 1mg.',
    expiry: 'May 30, 2026',
    status: 'ready',
    code: 'VITD50',
  },
  {
    id: 'c2',
    title: '20% Off Health Checkup',
    description: 'Complete blood panel with essential biomarkers.',
    expiry: 'Jun 15, 2026',
    status: 'pinned',
    code: 'HEALTH20',
  },
];

const couponStatusBadge = (status) => {
  const map = {
    ready: { label: 'Ready to Use', cls: 'badge-success' },
    assigned: { label: 'Open', cls: 'badge-info' },
    unused: { label: 'Open', cls: 'badge-info' },
    used: { label: 'Used', cls: 'badge-danger' },
    pinned: { label: 'Open', cls: 'badge-info' },
  };

  const { label, cls } = map[status] || map.assigned;

  return <span className={`badge ${cls}`}>{label}</span>;
};

const HEALTH_SUMMARY = {
  total: '3',
  risk: 'Low',
};

const DashboardPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [familyMembers, setFamilyMembers] = React.useState([]);
const [isFamilyLoading, setIsFamilyLoading] = React.useState(true);
  const familySectionRef = React.useRef(null);

  /* ─────────────────────────────────────────────
     FETCH FAMILY MEMBERS USING pnid QUERY PARAM
     Example:
     /dashboard?pnid=9876543210
  ───────────────────────────────────────────── */
  const[name,setName]=useState('');
  React.useEffect(() => {
    setName(localStorage.getItem('name'));
   const fetchFamilyMembers = async () => {
  try {
    setIsFamilyLoading(true); // ← start loading
    const number = localStorage.getItem('pnid');

    if (!number) {
      console.log('❌ pnid query param missing');
      setIsFamilyLoading(false); // ← stop loading
      return;
    }

    const response = await fetch('https://backend-coupon-distribution-nhf.onrender.com/family-number', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ number }),
    });

    if (!response.ok) throw new Error('Failed to fetch family members');

    const result = await response.json();

    if (result.success && result.data) {
      const formattedMembers = result.data.map((member, index) => ({
        id: member.id || index,
        name: member.name || 'Unknown',
        relation: `Member ${index + 1}`,
        couponStatus: 'assigned',
      }));
      setFamilyMembers(formattedMembers);
    } else {
      setFamilyMembers([]);
    }
  } catch (error) {
    console.error('❌ Error fetching family members:', error);
  } finally {
    setIsFamilyLoading(false); // ← always stop loading
  }
};

    fetchFamilyMembers();
  }, [searchParams]);

 
const getGreeting = () => {
  const hour = new Date().toLocaleString('en-US', {
    timeZone: 'Asia/Kolkata',
    hour: 'numeric',
    hour12: false,
  });

  const h = parseInt(hour);

  if (h >= 5 && h < 12) return 'Good morning 🌅';
  if (h >= 12 && h < 17) return 'Good afternoon ☀️';
  if (h >= 17 && h < 21) return 'Good evening 🌆';
  return 'Good night 🌙';
};
  return (
    <div className="db-root">
      {/* ── HEADER ── */}
      <header className="db-header">
        <div className="container">
<p className="db-greeting">{getGreeting()}</p>

          <h1 className="db-name">Hi, {name || 'there'} 👋</h1>

          <p className="db-company">
            {USER.company}
          </p>
        </div>
      </header>



      <div className="db-body container">
              {/* ── COUPON BANNER ── */}

        <div
  className="db-coupon-banner"
  onClick={() => navigate('/coupon')}
>
  <span className="db-coupon-shimmer" />

  <div className="db-coupon-left">
    <div className="db-coupon-icon-wrap">
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none"
        stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/>
        <line x1="7" y1="7" x2="7.01" y2="7"/>
      </svg>
    </div>

    <div className="db-coupon-text">
      <span className="db-coupon-eyebrow">Exclusive for you</span>
      <span className="db-coupon-title">Avail Your Coupons</span>
      <span className="db-coupon-sub">{COUPONS.length} offers waiting · Tap to redeem</span>
    </div>
  </div>

  <div className="db-coupon-right">
    <div className="db-coupon-badge-wrap">
      <span className="db-coupon-count">{COUPONS.length}</span>
      <span className="db-coupon-badge-label">Active</span>
    </div>
    <svg className="db-coupon-arrow" width="20" height="20" viewBox="0 0 24 24"
      fill="none" stroke="currentColor" strokeWidth="2.5"
      strokeLinecap="round" strokeLinejoin="round">
      <polyline points="9 18 15 12 9 6"/>
    </svg>
  </div>
</div>
        {/* ── HEALTH SNAPSHOT ── */}
        <section className="db-section">
          <h2 className="db-section-title">
            Health Snapshot
          </h2>

          <div className="db-summary-card">
            <div className="db-hs-table">
              {/* Header Row */}
              <div className="db-hs-row db-hs-row--header">
                <div className="db-hs-cell">
                  <span className="db-hs-col-head">
                    Score
                  </span>
                </div>

                <div className="db-hs-cell">
                  <span className="db-hs-col-head">
                    Result
                  </span>
                </div>

                <div className="db-hs-cell">
                  <span className="db-hs-col-head">
                    Score guide
                  </span>
                </div>
              </div>

              <div className="db-hs-divider" />

              {/* Data Row */}
              <div className="db-hs-row db-hs-row--data">
                <div className="db-hs-cell">
                  <span className="db-hs-score-val">
                    {HEALTH_SUMMARY.total}
                  </span>
                </div>

                <div className="db-hs-cell">
                  <div className="db-hs-result-wrap">
                    <span className="db-hs-result-dot" />

                    <span className="db-hs-result-text">
                      {HEALTH_SUMMARY.risk} Risk
                    </span>
                  </div>
                </div>

                <div className="db-hs-cell">
                  <div className="db-hs-guide-rows">
                    <div className="db-hs-guide-row">
                      <span className="db-hs-guide-val">
                        &lt; 5
                      </span>

                      <span className="db-hs-guide-arrow">
                        ⇒
                      </span>

                      <span className="db-hs-guide-chip db-hs-chip--adequate">
                        Adequate
                      </span>
                    </div>

                    <div className="db-hs-guide-row">
                      <span className="db-hs-guide-val">
                        ≥ 5
                      </span>

                      <span className="db-hs-guide-arrow">
                        ⇒
                      </span>

                      <span className="db-hs-guide-chip db-hs-chip--inadequate">
                        Inadequate
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Disclaimer */}
            <div
              className="db-hs-divider"
              style={{ marginTop: '14px' }}
            />

            <div className="db-hs-disclaimer">
              <svg
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#f59e0b"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                style={{
                  flexShrink: 0,
                  marginTop: '1px',
                }}
              >
                <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />

                <line x1="12" y1="9" x2="12" y2="13" />

                <line
                  x1="12"
                  y1="17"
                  x2="12.01"
                  y2="17"
                />
              </svg>

              <p>
                This is a screening test and not a
                substitute for a diagnostic test.
                Please consult your doctor for
                interpretation and appropriate
                treatment.
              </p>
            </div>
          </div>
        </section>


        {/* ── FAMILY BENEFIT NUDGE ── */}
        <button
          className="db-family-nudge"
        
        >
          <span className="db-nudge-shimmer" />

          <span className="db-nudge-left">
            <span className="db-nudge-icon">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#fff"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />

                <circle cx="9" cy="7" r="4" />

                <path d="M23 21v-2a4 4 0 00-3-3.87" />

                <path d="M16 3.13a4 4 0 010 7.75" />
              </svg>
            </span>

            <span className="db-nudge-label">
              <span className="db-nudge-eyebrow">
                Family offer
              </span>

              <span className="db-nudge-text">
                Avail this benefit for your family too
              </span>
            </span>
          </span>

          <span className="db-nudge-right">
            <span className="db-nudge-pill">
              Free to add
            </span>

            <svg
              className="db-nudge-arrow"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </span>
        </button>

        {/* ── FAMILY MEMBERS ── */}
        <section
          className="db-section"
          ref={familySectionRef}
        >
          <div className="db-section-header">
            <h2 className="db-section-title">
              Family Members
            </h2>

            <button
              className="db-add-btn"
              onClick={() =>
                navigate('/add-family')
              }
              id="add-family-btn"
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line
                  x1="12"
                  y1="5"
                  x2="12"
                  y2="19"
                />

                <line
                  x1="5"
                  y1="12"
                  x2="19"
                  y2="12"
                />
              </svg>

              Add
            </button>
          </div>

          <div className="db-family-list">
  {isFamilyLoading ? (
    <div className="db-family-empty">
      {/* Skeleton loaders */}
      {[1, 2, 3].map((i) => (
        <div key={i} className="db-family-item" style={{ opacity: 0.4, pointerEvents: 'none' }}>
          <div className="db-family-avatar" style={{ background: '#e5e7eb' }} />
          <div className="db-family-info">
            <p className="db-family-name" style={{ background: '#e5e7eb', borderRadius: 4, color: 'transparent', width: 100 }}>
              Loading
            </p>
            <p className="db-family-relation" style={{ background: '#e5e7eb', borderRadius: 4, color: 'transparent', width: 60 }}>
              Loading
            </p>
          </div>
        </div>
      ))}
    </div>
  ) : familyMembers.length > 0 ? (
    familyMembers.map((m) => (
      <div
        key={m.id}
        className="db-family-item"
        style={{ cursor: 'pointer' }}
        onClick={() => navigate(`/family-member-details?id=${m.id}`)}
      >
        <div className="db-family-avatar">{m.name.charAt(0)}</div>
        <div className="db-family-info">
          <p className="db-family-name">{m.name}</p>
          <p className="db-family-relation">{m.relation}</p>
        </div>
        {couponStatusBadge(m.couponStatus)}
      </div>
    ))
  ) : (
    <div className="db-family-empty">
      {/* your existing empty state SVG + button */}
      <button className="db-empty-add-btn" onClick={() => navigate('/add-family')}>
        + Add your first member
      </button>
    </div>
  )}
</div>
        </section>

  

      

      </div>
    </div>
  );
};

export default DashboardPage;